import { useFormikContext } from 'formik';
import { camelCase } from 'lodash';
import React, { useEffect, useMemo } from 'react';
import { generatePath, useLocation, useNavigate } from 'react-router-dom';

import { RadioField } from 'Shared/form/RadioField';
import { DatePickerField } from 'Shared/form/DatePickerField';
import { dateRangeOptions } from '../../workQueue.constant';
import { setWorkQueueFilterGenerator } from '../../workQueue.utils';

const DateRangeFilter = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { values, setFieldValue } = useFormikContext();
    const {
        result: { activityCountResult },
        filterParams,
    } = values;
    const setWorkQueueFilter = setWorkQueueFilterGenerator(setFieldValue);

    const options = useMemo(() => {
        return dateRangeOptions.map((range) => {
            const activityCount = activityCountResult[camelCase(range.value)];
            return {
                id: range.value,
                option: `${range.name} ${activityCount >= 0 ? `(${activityCount})` : ''}`,
            };
        });
    }, [activityCountResult]);

    useEffect(() => {
        if (filterParams.type) {
            const newPath = generatePath(location.pathname, {
                dateFilter: filterParams.type,
            });
            if (newPath !== location.pathname) {
                navigate(newPath);
            }
        }
    }, [filterParams.type, navigate, location.pathname]);
    return (
        <>
            <div className="filter form-group">
                <RadioField
                    fieldName="filterParams.type"
                    label="Date Range"
                    options={options}
                    onChange={(e) => setWorkQueueFilter(filterParams, 'type', e.target.value, true)}
                />
            </div>
            {values.filterParams.type === 'custom' && (
                <>
                    <DatePickerField
                        fieldName="filterParams.dateStart"
                        label="Date Range Start"
                        onChange={(date) => setWorkQueueFilter(filterParams, 'dateStart', date, true)}
                        maxDate={filterParams.dateEnd}
                    />
                    <DatePickerField
                        fieldName="filterParams.dateEnd"
                        label="Date Range End"
                        onChange={(date) => setWorkQueueFilter(filterParams, 'dateEnd', date, true)}
                        minDate={filterParams.dateStart}
                    />
                </>
            )}
        </>
    );
};

export default DateRangeFilter;
